module.exports = ".fix-height-45 {\n  height: 45px; }\n"